module.exports = __webpack_public_path__ + "img/down_arrow.5a29368c.svg";